import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { LabService } from 'src/app/_service/lab.service';
@Component({
  selector: 'app-add-subcategory',
  templateUrl: './add-subcategory.component.html',
  styleUrls: ['./add-subcategory.component.css']
})
export class AddSubcategoryComponent implements OnInit {
  labTest = []; labTest_copy = [];subCategoryModalForm: FormGroup;loading:boolean=false;submitted:boolean=false;
  constructor(public dialogRef: MatDialogRef<AddSubcategoryComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,private dialog:MatDialog,
  private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder, private labapi: LabService) {
    this.subCategoryModalForm = this.formBuilder.group({
      'lab_test_category': [null, Validators.required],
      'lab_test_subcategory': [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.getLabTestCategory();
  }

  get f() { return this.subCategoryModalForm.controls; }


  async getLabTestCategory() {
    await this.labapi.getLabTestCategory().subscribe((data: any) => {
        if (data.status) {
            this.labTest = data.data;
            this.labTest_copy = this.labTest;
        } else {
            this.labTest = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  CloseModal(): void {
    this.dialogRef.close();
  }

  async submitSubCategory()
  {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.subCategoryModalForm.invalid) {
        this.loading = false;
        return;
    }
    //For Add Sub Category//
    await this.labapi.addSubCategory(this.subCategoryModalForm.value)
    .subscribe((data: any) => {
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.dialogRef.close();
          this.sharedapi.presentToast('Sub Category has been submitted successfully.');
        }
        else 
        {
          this.sharedapi.presentToast(data.msg);
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

}
